import { render, staticRenderFns } from "./result.vue?vue&type=template&id=49351683&scoped=true&"
import script from "./result.vue?vue&type=script&lang=js&"
export * from "./result.vue?vue&type=script&lang=js&"
import style0 from "./result.vue?vue&type=style&index=0&id=49351683&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49351683",
  null
  
)

export default component.exports